<div (clickOutside)="clickOutside()" class="language-dropdown">
  <div class="input-title">{{ title() }}</div>
  <div
    (click)="toggleDropdown()"
    [class.is-open]="isDropdownOpen"
    class="dropdown-input"
  >
    <span>{{ placeholder() }}</span>
    <i class="icon icon-CaretDown"></i>
  </div>

  @if (isDropdownOpen) {
    <div class="dropdown-body">
      @for (item of dropdownOptions; track item.length) {
        <div class="item" (click)="selectItem(item)">
          {{ item }}
        </div>
      }
    </div>
  }
  <div class="selected-items">
    @for (item of selectedItems; track item) {
      <div class="selected-item">
        <span>{{ item }}</span>
        <i class="icon-X" (click)="removeItem(item)"></i>
      </div>
    }
  </div>

</div>
